export const USER_ROLES = {
  CUSTOMER: 'customer',
  BUSINESS: 'business',
  DRIVER: 'delivery_driver',
  ADMIN: 'admin',
}

export interface DriverStats {
  isAvailable: boolean
  totalOrders: number
  completedOrders: number
}

export interface FilterObject {
  search: string
  selectedRole: string
  hasBankAccount: boolean
}

export interface Order {
  id: number
  uuid: string,
  total_amount: number,
  subtotal: number,
  status: string,
  payment_status: string,
  payment_reference: string,
  delivery_address: string,
  phone: string,
  business: Business,
  customer: User,
  items: OrderItem[],
  notes?: string,
  service_fee: number,
  service_fee_percentage: number,
  business_service_fee: number,
  business_service_fee_percentage: number,
  delivery_fee: number,
  packs?: number,
  price_per_pack?: number,
  created_at: string,
  updated_at: string,
}

export interface Notification {
  id: number
  type: string
  data: any
  read_at: string | null
  created_at: string
  updated_at: string
}

export interface Review {
  id: number
  user_id: number
  business_id: number
  rating: number
  comment: string
  created_at: string
  updated_at: string
  user: {
    id: number
    name: string
    email: string
  }
}

export interface OrderItem {
  id: number
  name: string
  description?: string | null,
  order_id: number,
  product_id: number,
  price: number,
  quantity: number,
  created_at: string,
  updated_at: string,
  product: Product,
}

export interface Review {
  id: number
  rating: number
  comment: string
  business_id: number
  customer_id: number
  created_at: string
  updated_at: string
}
export interface Category {
  id: number
  name: string
  description?: string | null,
}
export interface SubCategory {
  id: number
  name: string
  description?: string
}
export interface Product {
  id: number
  name: string
  price: number
  stock: number | null
  image: string | null
  description?: string | null,
  category_id?: number | null,
  sub_category_id?: number | null,
  is_available?: boolean,
  created_at?: string,
  updated_at?: string,
  image_url?: string,
}

export interface Business {
  id: number,
  uuid: string,
  name: string,
  slug?: string,
  description?: string,
  address?: string,
  email?: string,
  category?: string,
  phone?: string,
  logo?: string,
  is_active: boolean,
  products?: Product[],
  reviews?: Review[],
  user?: User,
  created_at?: string,
  updated_at?: string,
}

export interface Stats {
  total_orders?: number
  total_businesses?: number
  total_products?: number
  is_active?: boolean
}

export interface BankAccount {
  id: number,
  account_number: string,
  account_name: string,
  bank_code: string,
  transaction_receipt_code: string,
  bank_name: string,
}

export interface User {
  id: number,
  uuid: string,
  name: string,
  role: string,
  phone: string,
  image_url?: string,
  address?: string,
  email: string,
  email_verified_at?: string,
  created_at?: string,
  updated_at?: string,
  is_deactivated?: boolean,
  business?: Business,
  bank_account?: BankAccount
}

